export default __webpack_public_path__ + "static/media/remos.105dd5ce.png";